import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import MeasurementHistoryList from './MeasurementHistoryList';

loadDOMComponent({
	selector: 'react-measurement-history-list',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('userId');
		const measurementKey = container.getAttribute('measurementKey');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<MeasurementHistoryList
						userId={userId}
						measurementKey={measurementKey}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
